import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function CtaFinal({ onOpenQuote }) {
  return (
    <section
      data-testid="cta-final"
      className="relative py-24 md:py-36 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #E52431 0%, #7E1945 35%, #2A2A5F 70%, #1F2C6E 100%)",
      }}
    >
      {/* Subtle overlay to tone down for readability */}
      <div className="absolute inset-0 bg-[#0A0A0A]/20" />
      <div className="grain absolute inset-0" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent,rgba(10,10,10,0.4))]" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-outfit text-4xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.05] text-white"
        >
          Prêt à passer au{" "}
          <span className="font-medium italic">niveau supérieur</span>{" "}?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-8 text-white/80 text-lg md:text-xl font-light max-w-2xl mx-auto"
        >
          Offrez à votre marque l'image qu'elle mérite. Choisissez un visuel,
          ou parlons de votre site web.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href="#tarifs"
            data-testid="cta-final-acheter"
            className="inline-flex items-center gap-2 rounded-full bg-white text-[#0A0A0A] font-semibold px-10 py-5 text-sm uppercase tracking-[0.15em] hover:scale-[1.03] hover:shadow-[0_0_50px_rgba(255,255,255,0.3)] transition-all duration-300 btn-shine"
          >
            Acheter un visuel
            <ArrowRight size={18} />
          </a>
          <button
            data-testid="cta-final-devis"
            onClick={onOpenQuote}
            className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-md border border-white/30 text-white font-semibold px-10 py-5 text-sm uppercase tracking-[0.15em] hover:bg-white/20 hover:scale-[1.03] transition-all duration-300"
          >
            Demander un devis
          </button>
        </motion.div>
      </div>
    </section>
  );
}
